var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-absolute fixed-top fill-vw text-center",class:{ on: !_vm.isHide },attrs:{"id":"toastTop","role":"alert"}},[_c('span',{staticClass:"message position-absolute fill-vw alert alert-border",class:{ end: _vm.isHide }},[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }